import { render } from "./RolesView.vue?vue&type=template&id=e009c8fc&scoped=true"
import script from "./RolesView.vue?vue&type=script&lang=js"
export * from "./RolesView.vue?vue&type=script&lang=js"

import "./RolesView.vue?vue&type=style&index=0&id=e009c8fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e009c8fc"]])

export default __exports__